import { DeepPartial, AppConfig } from "../../../../src/app/interfaces/app-config";

export const projectConfig: DeepPartial<AppConfig> = {
    // Ejemplo
     pages: {
         login: {
             title: 'Iniciar sesión',
         },
         users: {
            titlePlural: 'Usuarios',
            titleSingular: 'Usuario',
            form: {
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                password: {
                    label: 'Contraseña',
                    placeholder: 'Ingresa tu contraseña'
                },
                image: {
                    label: 'Imagen',
                    placeholder: 'Selecciona una imagen'
                },
                rol: {
                    label: 'Asignar rol',
                    placeholder: 'Selecciona....'
                },
                agency: {
                    label: 'Agencia',
                    placeholder: 'Seleccionar agencia....'
                },
                city: {
                    label: 'Ciudad',
                    placeholder: 'Seleccionar ciudad....'
                }
            },
            form_filter:{
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
            },
        },
        agency: {
            titlePlural: 'Agencias',
            titleSingular: 'Agencia',
            form: {
                name: {
                    label: 'Nombre de la agencia ',
                    placeholder: 'Ingresa tu nombre..'
                },
                address: {
                    label: 'Dirección',
                    placeholder: 'Ingresa dirección...'
                },
                phone: {
                    label: 'Telefono',
                    placeholder: 'Ingresa telefono...'
                },
                business: {
                    label: 'Empresa',
                    placeholder: 'Ingresa nombre de empresa...'
                },
                latitude: {
                    label: 'Latitude',
                    placeholder: 'Latitude....'
                },
                longitude: {
                    label: 'Longitude',
                    placeholder: 'Longitude....'
                },
                description: {
                    label: 'Descripción',
                    placeholder: 'Ingresa descripción....'
                }
            },
            form_filter:{
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
            }

        },
        customer: {
            titlePlural: 'Clientes',
            titleSingular: 'Cliente',
            form: {
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                cellphone: {
                    label: 'Celular',
                    placeholder: 'Ingresa tu número de celular'
                },
                code: {
                    label: 'Contraseña',
                    placeholder: 'Ingresa contraseña'
                },
            },
            form_filter:{
                name: {
                    label: 'Nombres y Apellidos',
                    placeholder: 'Ingresa tu nombre completo'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Ingresa tu correo electrónico'
                },
                cellphone: {
                    label: 'Celular',
                    placeholder: 'Ingresa tu número de celular'
                },
                initial_date: {
                    label: 'Fecha inicio',
                    placeholder: 'Ingresa fecha inicio'
                },
                end_date: {
                    label: 'Fecha fin',
                    placeholder: 'Ingresa fecha fin'
                },
            }
        },
         profile: {
            titlePlural: 'Perfiles',
            titleSingular: 'Perfil',
            form:{
                name: {
                    label: 'Nombre',
                    placeholder: 'Escribir nombre'
                },
                last_name: {
                    label: 'Apellido',
                    placeholder: 'Escribir apellido...'
                },
                email: {
                    label: 'Correo electrónico',
                    placeholder: 'Escribir correo electrónico...'
                },
                cellphone: {
                    label: 'Celular',
                    placeholder: 'Escribir celular...'
                },
                birth_date: {
                    label: 'Fecha de nacimiento',
                    placeholder: 'Escribir Fecha de nacimiento...'
                },
                city: {
                    label: 'Ciudad',
                    placeholder: 'Escribir ciudad...'
                },
                country: {
                    label: 'País',
                    placeholder: 'Escribir paós...'
                },
                ci:{
                    label: 'Carnet',
                    placeholder: 'Ingrese...'
                },
            },
            form_filter: {
                name:{
                    label: 'Nombre',
                    placeholder: 'Escribir nombre'
                },
                lastName:{
                    label: 'Apellido',
                    placeholder: 'Escribir apellido'
                },
                email:{
                    label: 'Correo electrónico',
                    placeholder: 'Escribir correo electrónico'
                },
                numberCi:{
                    label: 'Numero de carnet',
                    placeholder: 'Escribir numero carnet'
                },
                initial_date:{
                    label: 'Fecha inicio',
                    placeholder: 'Escribir...'
                },
                end_date:{
                    label: 'Fecha fin',
                    placeholder: 'Escribir...'
                },
                city:{
                    label: 'Ciudad',
                    placeholder: 'Escribir...'
                },
                event:{
                    label: 'Eventos',
                    placeholder: 'Seleccionar...'
                },

            }
        },

        historyTickets: {
            titlePlural: 'Reporte de ventas',
            titleSingular: 'Reporte de venta',
            form:{},
            form_filter: {
                search: {
                    label: 'Buscar código',
                    placeholder: 'Escribir código...'
                },
                name:{
                    label: 'Nombre',
                    placeholder: 'Escribir nombre...'
                },
                lastName:{
                    label: 'Apellido',
                    placeholder: 'Escribir apellido...'
                },
                email:{
                    label: 'Correo electrónico',
                    placeholder: 'Escribir correo electrónico...'
                },
                numberCi:{
                    label: 'Numero de carnet',
                    placeholder: 'Escribir numero de carnet...'
                },
                initial_date:{
                    label: 'Fecha inicio',
                    placeholder: 'Escribir fecha inicio...'
                },
                end_date:{
                    label: 'Fecha fin',
                    placeholder: 'Escribir fecha fin...'
                },
                event:{
                    label: 'Eventos',
                    placeholder: 'Seleccionar evento...'
                },
                type:{
                    label: 'Tipo de reserva',
                    placeholder: 'Seleccionar...'
                },
            }
        },
        sendMail: {
            titlePlural: 'Correos enviados',
            titleSingular: 'Correo enviado',
            form:{},
            form_filter: {
                type: {
                    label: 'Tipo de notificación',
                    placeholder: 'Seleccionar...'
                },
                status:{
                    label: 'Estado',
                    placeholder: 'Seleccionar...'
                },
                token:{
                    label: 'Buscar por token',
                    placeholder: 'Escribir...'
                },
            }
        },
        salesReport: {
            titlePlural: 'Reportes de ventas',
            titleSingular: 'Reporte de venta',
            form:{},
            form_filter: {
                search: {
                    label: 'Buscar código',
                    placeholder: 'Escribir código...'
                },
                name:{
                    label: 'Nombre',
                    placeholder: 'Escribir nombre...'
                },
                lastName:{
                    label: 'Apellido',
                    placeholder: 'Escribir apellido...'
                },
                email:{
                    label: 'Correo electrónico',
                    placeholder: 'Escribir correo electrónico...'
                },
                numberCi:{
                    label: 'Numero de carnet',
                    placeholder: 'Escribir numero de carnet...'
                },
                initial_date:{
                    label: 'Fecha inicio',
                    placeholder: 'Escribir fecha inicio...'
                },
                end_date:{
                    label: 'Fecha fin',
                    placeholder: 'Escribir fecha fin...'
                },
                event:{
                    label: 'Eventos',
                    placeholder: 'Seleccionar evento...'
                },
            }
        },
        assistance: {
            titlePlural: 'Asistencias',
            titleSingular: 'Asistencia',
            form:{},
        },
        seats: {
            titlePlural: 'Reporte de asientos',
            titleSingular: 'Reporte de asiento',
            form:{},
        },

     },

    menu: [
        {
            headTitle1: "General",
            permissions:'default',
        },
        {
            id: 1,
            level: 1,
            path: '/account',
            title: "Mi Cuenta",
            icon: "home",
            type: "link",
            permissions:'default',
        },
        {
            id: 1,
            level: 1,
            path: '/event',
            title: "Administrador de Eventos",
            icon: "home",
            type: "link-external-admin",
            permissions:'organization-page-ticket',
        },
        {
            headTitle1: "Usuarios",
            permissions:'default',
        },
        {
            id: 2,
            level: 1,
            path: '/users',
            title: "Usuarios del admin",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-users',
        },
        {
            id: 3,
            level: 1,
            path: '/profile',
            title: "Perfiles",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-profiles',
        },
        {
            id: 4,
            level: 1,
            path: '/customer',
            title: "Clientes",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-customers',
        },
        {
            id: 5,
            level: 1,
            path: '/agency',
            title: "Agencia",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-agency',
        },

        /* {
            headTitle1: "Predios",
            permissions:'default',
        },
        {
            id: 2,
            level: 1,
            path: '/location/create',
            title: "Crear predios",
            icon: "bookmark",
            type: "link-external-admin",//link-external-admin,link,extTabLink
            permissions: 'default'
        },
        {
            id: 3,
            level: 1,
            path: '/location',
            title: "Predios habilitados",
            icon: "bookmark",
            type: "link-external-admin",//link-external-admin, link, extTabLink
            permissions: 'default'
        },
        {
            id: 4,
            level: 1,
            path: '/location/list-archived',
            title: "Predios archivados",
            icon: "bookmark",
            type: "link-external-admin",//link-external-admin, link, extTabLink
            permissions: 'default'
        }, */
        {
            headTitle1: "Tickets",
            permissions:'default',
        },
        {
            id: 5,
            level: 1,
            path: 'history-tickets',
            title: "Reporte de ventas",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-history_tickets',
        },
        {
            id: 5,
            level: 1,
            path: 'assistance',
            title: "Reporte de asistencia",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-assistance',
        },
        {
            id: 5,
            level: 1,
            path: 'report-seats',
            title: "Reporte de Asientos",
            icon: "bookmark",
            type: "link",
            permissions:'defaultt',
        },
        {
            headTitle1: "Notificaciones",
            permissions:'organization-page-send_email',
        },
        {
            id: 5,
            level: 1,
            path: 'send-email',
            title: "Correos enviados",
            icon: "bookmark",
            type: "link",
            permissions:'organization-page-send_email',
        },

    ]
};
